<div
  class="toast-item"
  [class.toast-item--info]="toast().type === 'info'"
  [class.toast-item--warning]="toast().type === 'warning'"
  [class.toast-item--error]="toast().type === 'error'"
  [class.toast-item--success]="toast().type === 'success'"
>
  <span class="toast-item__accent" aria-hidden="true"></span>
  <img
    class="toast-item__icon"
    [src]="iconPath()"
    width="20"
    height="20"
    alt=""
  />
  <span class="toast-item__message">{{ toast().message }}</span>
</div>
